import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import Loading from 'components/Loading/Loading';
import { compactDateTime } from '../../../../utils/timeUtils';

import { searchTeachers, suspendTeacher } from '../../../../actions/Admin/manageTeacherActions';

import './style.css';

const renderField = ({
  input,
  type,
  placeholder,
  disabled,
}) => {
  return (
    <input id={input.name} {...input} disabled={disabled} placeholder={placeholder} type={type} />
  );
};

class ManageTeachers extends Component {
  constructor() {
    super();
    this.typingTimeout = null;
    this.state = {};
  }

  componentWillMount() {
    this.props.searchTeachers('');
  }

  clearForm = () => {
    this.props.reset();
  }

  searchTeachers = e => {
    clearTimeout(this.typingTimeout);
    const text = e.target.value;
    this.typingTimeout = setTimeout(() => {
      this.props.searchTeachers(text);
    }, 500);
  }

  suspendTeacher = (teacherId, suspend) => {
    this.setState({ isUpdatingTeacher: teacherId });
    this.props.suspendTeacher(
      teacherId,
      suspend,
      () => {
        this.setState({ isUpdatingTeacher: null });
      },
      () => {
        this.setState({ isUpdatingTeacher: null });
      }
    );
  }

  renderSearchForm() {
    // const { handleSubmit, submitting, resetForm } = this.props;
    return (
      <div className="search-form">
        <form>
          <Field
            name="teacherSearch"
            component={renderField}
            type="text"
            label="Teacher Name or Email"
            placeholder="Teacher Name or Email"
            onChange={this.searchTeachers}
          />
        </form>
      </div>
    );
  }

  render() {
    const teachers = this.props.teachers.teachers ?
      this.props.teachers.teachers.filter(t => t.information != null) :
      null;
    const { status } = this.props.teachers;

    return (
      <div className="ManageTeachers">
        <div className="col-auto">
          <div className="row">{this.renderSearchForm()}</div>

          <div className="row">
            <div className="card">
              {status === 'LOADING' && <Loading />}
              {(status === 'SUCCESS' || status === 'UPDATING') && (
                <table className="table table-striped table-sm table-hover borderless">
                  <thead>
                    <tr>
                      <th scope="col">Teacher ID</th>
                      <th scope="col">Teacher Name</th>
                      <th scope="col">Teacher Email</th>
                      <th scope="col">Created At</th>
                      <th scope="col">Suspend</th>
                    </tr>
                  </thead>
                  <tbody>
                    {teachers.map(teacher => (
                      <tr key={teacher.id}>
                        <td>{teacher.id}</td>
                        <td>{teacher.name}</td>
                        <td>{teacher.email}</td>
                        <td>{compactDateTime(teacher.createdAt)}</td>
                        <td>
                          {teacher.information.suspendedAt === null ? (
                            <button
                              disabled={this.state.isUpdatingTeacher === teacher.id}
                              className="btn btn-secondary"
                              type="button"
                              onClick={() => this.suspendTeacher(teacher.id, true)}
                            >
                              Suspend
                            </button>
                          ) : (
                            <button
                              disabled={this.state.isUpdatingTeacher === teacher.id}
                              className="btn btn-secondary"
                              type="button"
                              onClick={() => this.suspendTeacher(teacher.id, false)}
                            >
                              Unsuspend
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {this.props.teachers.status === 'FAIL' && <div>Problem</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    teachers: state.teacherSearchResults
  };
}

export default compose(
  connect(mapStateToProps, {
    searchTeachers,
    suspendTeacher
  }),
  reduxForm({
    form: 'searchTeachersForm',
    enableReinitialize: true
  })
)(ManageTeachers);



// WEBPACK FOOTER //
// ./src/pages/admin/routes/ManageTeachers/index.js